import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { getClazzSortBook, getSortbook } from '../../model/api'
import { TERM_LIST } from '../../model/publish'
const UCENTER = process.env.VUE_UCENTER_DOMAIN || 'https://ucenter.test.17zuoye.net/'
@Component
export default class BookSelector extends Vue {
  @Prop() public clazzLevelList!: any[]
  @Prop() public defaultBook!: any
  @Prop() public value!: boolean
  @Prop() public subject!: any
  @Prop() public isClazz!: boolean

  public searchText: any = ''
  private visible = false
  private selectedTerm = []
  private selectedGrade = []
  private bookList = []
  private termlist = TERM_LIST
  private selectBook: any[] = []
  @Watch('value')
  public onValueChange(val) {
    if (val) {
      this.visible = true
    }
  }
  @Watch('defaultBook', { deep: true, immediate: true })
  public onDefaultBookChange(val) {
    if (val && val.bookId) {
      this.selectBook = [
        {
          bookName: val.bookName,
          bookId: val.bookId
        }
      ]
      this.selectedTerm = val.termType
      this.selectedGrade = val.clazzLevel
      this.getSortbook()
    }
  }
  public getContainer() {
    return document.getElementById('book_selector')
  }
  public handleOK() {
    this.$emit('ok', this.selectBook)
    this.visible = false
  }
  public handleCancel() {
    this.$emit('cancel')
  }
  public async getSortbook() {
    if (this.isClazz) {
      const data: any = await getClazzSortBook({
        subject: this.subject && this.subject.nick,
        level: Number(this.selectedGrade),
        term: Number(this.selectedTerm)
      })
      if (data.success) {
        this.bookList = data.rows.map((item) => {
          item.bookName = item.name
          item.bookId = item.id
          return item
        })
      } else {
        this.bookList = []
      }
    } else {
      const data: any = await getSortbook({
        subject: this.subject && this.subject.nick,
        level: Number(this.selectedGrade),
        term: Number(this.selectedTerm)
      })
      if (data.success) {
        this.bookList = data.rows.map((item) => {
          item.bookName = item.name
          item.bookId = item.id
          return item
        })
      } else {
        this.bookList = []
      }
    }
  }

  public onSearch() {
    let searchText = this.searchText.trim()
    if (searchText !== '') {
      this.bookList = this.bookList.filter((bookObj: any) => {
        return bookObj.name.toLowerCase().indexOf(this.searchText) !== -1
      })
    } else {
      this.getSortbook()
    }
  }

  public onBookClear() {
    this.selectBook = []
  }
  public onSelect(itm) {
    this.selectBook = [itm]
  }
  public onRadioChange() {
    this.getSortbook()
  }
  // 点击设置班组信息
  public onClazzsSettingClick() {
    window.open(UCENTER + '/teacher/systemclazz/clazzindex.vpage?step=showtip')
  }
}
